
export abstract class ApplicationError {
  code: any;
  message: string;
  constructor(code: any, message: string) {
    this.code = code;
    this.message = message;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/errors/application-error.model.ts